module.exports = __webpack_public_path__ + "static/media/share.svg?v=77473e8d";